import React from 'react';
import {ActivityIndicator} from '@bosch/react-frok';
import {Container} from './LoadingIndicator.style';

/**
 * @name LoadingIndicator
 * @description
 * A centered indicator for showing a loading state
 */
export const LoadingIndicator: React.VFC = () => {
    return (
        <Container>
            <ActivityIndicator/>
        </Container>
    );
};
